import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';

import UnfreezeCardForm from './components/UnfreezeCardForm';

export default function UnfreezeCardModal({ handleClose, cardId, last4Digits }) {
  return (
    <FormModal handleClose={handleClose}>
      <UnfreezeCardForm
        cardId={cardId}
        handleClose={handleClose}
        last4Digits={last4Digits}
      />
    </FormModal>
  );
}

UnfreezeCardModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  cardId: PropTypes.string.isRequired,
  last4Digits: PropTypes.string.isRequired
};
